<template>
    <div class="col-sm-3 col-md-2 sidebar">
        <div class="top-navigation">
            <div class="t-menu">選單</div>
            <div class="t-img">
                <img src="@/assets/images/lines_2.png" alt=""/>
            </div>
            <div class="clearfix"></div>
        </div>
        <div class="drop-navigation drop-navigation">
            <ul class="nav nav-sidebar">

                <li @click="menuActive('active-home')">
                    <router-link :to="{name: 'Home'}" class="menu-icon menu-icon-home" :class="{menuactive: active_menu == 'active-home'}">
                        <span class="glyphicon glyphicon-home" aria-hidden="true"></span>首頁
                    </router-link>
                </li>
                <li @click="menuActive('active-live')">
                    <router-link :to="{name: 'LiveList'}" class="menu-icon menu-icon-live" :class="{menuactive: active_menu == 'active-live'}">
                        <span class="glyphicon glyphicon-facetime-video" aria-hidden="true"></span>直播列表
                    </router-link>
                </li>
                <li>
                    <a href="javascript:void(0);" class="menu-down menu-icon">
                        <span class="glyphicon glyphicon-film" aria-hidden="true"></span>影片類別
                        <span class="glyphicon glyphicon-menu-down" aria-hidden="true"></span>
                    </a>
                </li>
                <ul class="menu-down-list">
                    <li v-for="(data, index) in categoryList" @click="menuActive('active-video'+data.id)" :key="index">
                        <router-link :to="{name: 'VideoList', params:{ cid:data.id }}" class="menu-icon" :class="{menuactive: active_menu == 'active-video'+data.id}">{{ data.title }}</router-link>
                    </li>
                </ul>
            </ul>
            <!-- script-for-menu -->
<!--            <div class="side-bottom">-->
<!--                <div class="copyright">-->
<!--                    <p>Copyright © 2020 <a href="http://www.chjhs.tp.edu.tw/dispPageBox/MainHp.aspx?ddsPageID=MAINHP" target="_blank">臺北市私立靜心高級中學</a> All rights reserved. | <a href="http://www.ginnet.com.tw" target="_blank">啟迪國際影音平台</a></p>-->
<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      active_menu: this.$route.matched[0].meta.menuCss || '',
      categoryList: []
    }
  },
  watch: {
    '$route' (to, from) {
      this.active_menu = this.$route.matched[0].meta.menuCss
      $('.drop-navigation').css('display', '')
    }
  },
  mounted () {
    this.getVideoCategorys()

    $('.top-navigation').click(function () {
      $('.drop-navigation').slideToggle(300, function () {
        // Animation complete.
        if ($('.drop-navigation').css('display') === 'none') {
          $('.drop-navigation').css('display', '')
        }
      })
    })

    $('li a.menu-down').click(function () {
      $('ul.menu-down-list').slideToggle(300, function () {})
    })
  },
  methods: {
    getVideoCategorys () {
      let self = this
      this.$http.get('/getVideoCates')
        .then(function (response) {
          self.categoryList = response.data.list
        }).catch(err => {
          console.log(err.response.data.msg)
        })
    },
    menuActive (el) {
      this.active_menu = el
    }
  }
}
</script>

<style>
    /*.menu-icon.router-link-exact-active{*/
        /*background-color: #103151 !important;*/
        /*color: #FFFFFF !important;*/
    /*}*/
    .menuactive{
        background-color: #103151 !important;
        color: #FFFFFF !important;
    }
</style>
